import { BRAND_NAME } from "../../../../constants/commonStrings";

export function checkBrandUserAgent(): boolean {
  const userAgent = navigator.userAgent;
  if (userAgent == null) {
    return false;
  }

  return userAgent.toLowerCase().includes(BRAND_NAME.toLowerCase());
}
